var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('next-steps-base-card',{attrs:{"title":"לפתוח חיסכון דינאמי דרך  רייזאפ","button-text":"לחיסכון לטווח ארוך","description":"5 דקות, פתיחת קופת גמל","action-key":_vm.actionKey,"disabled":_vm.hasFunds},on:{"click":_vm.goToLongTermSaving}})}
var staticRenderFns = []

export { render, staticRenderFns }